import { shareReplay, distinctUntilChanged } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Category, LocalizedQuestionCategory } from '../models/questions';

@Injectable()
export class CategoriesService {
  apiUrl = 'api/admin/category';
  saveOnAddCategoryClicked$: Observable<Category> = new Observable();
  saveOnEditCategoryClicked$: Observable<Category> = new Observable();
  deleteCategoryClicked$: Observable<any> = new Observable();

  private saveOnEditCategorySubject = new Subject();
  private saveOnAddCategorySubject = new Subject();
  private deleteCategorySubject = new Subject();

  constructor(private http: HttpClient) {
    this.saveOnEditCategoryClicked$ = this.saveOnEditCategorySubject.asObservable();
    this.saveOnAddCategoryClicked$ = this.saveOnAddCategorySubject.asObservable();
    this.deleteCategoryClicked$ = this.deleteCategorySubject.asObservable();
  }

  saveOnAddCategoryClicked(category: Category) {
    this.saveOnAddCategorySubject.next(category);
  }

  saveOnEditCategoryClicked(category: Category) {
    this.saveOnEditCategorySubject.next(category);
  }

  deleteCategoryClicked() {
    this.deleteCategorySubject.next();
  }

  getAll(): Observable<Array<Category>> {
    return this.http.get(this.apiUrl) as Observable<Array<Category>>;
  }

  getOne(id: number): Observable<Category> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  getWithQuestions(): Observable<Array<LocalizedQuestionCategory>> {
    return this.http.get(`${this.apiUrl}/questions`) as Observable<
      Array<LocalizedQuestionCategory>
    >;
  }

  update(category: Category) {
    return this.http
      .put(`${this.apiUrl}/${category.id}`, category)
      .pipe(shareReplay())
      .pipe(distinctUntilChanged());
  }

  create(category: Category) {
    return this.http
      .post(`${this.apiUrl}`, category)
      .pipe(shareReplay())
      .pipe(distinctUntilChanged());
  }

  delete(id: number) {
    return this.http
      .delete(`${this.apiUrl}/${id}`)
      .pipe(shareReplay())
      .pipe(distinctUntilChanged());
  }
}
